import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface Props {
  data: Array<{ date: string; rating: number }>;
  height?: number;
}

export function MoodLineChart({ data, height = 240 }: Props) {
  const filled = data.length > 0 ? data : [{ date: new Date().toISOString().slice(0, 10), rating: 0 }];
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <LineChart data={filled} margin={{ top: 16, right: 16, bottom: 16, left: 0 }}>
          <CartesianGrid stroke="#d9d9dd" vertical={false} />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: '#75758a' }}
            tickFormatter={(d: string | number) => new Date(d).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
            stroke="#d9d9dd"
          />
          <YAxis
            domain={[0, 5]}
            ticks={[1, 2, 3, 4, 5]}
            tick={{ fontSize: 11, fill: '#75758a' }}
            stroke="#d9d9dd"
          />
          <Tooltip
            contentStyle={{ background: '#fff', border: '1px solid #d9d9dd', borderRadius: 8, fontSize: 12 }}
            labelStyle={{ color: '#212121' }}
          />
          <Line
            type="monotone"
            dataKey="rating"
            stroke="#ff7759"
            strokeWidth={2.5}
            dot={{ fill: '#ff7759', r: 3 }}
            activeDot={{ r: 5 }}
            connectNulls
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
